<template>
  <div>

    <div @click="back()" style="height: 30px;width: 60px;display: flex;align-items: center;cursor: pointer;">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path
          d="M10.9825 3.58692L10.2867 2.89111L3.85938 9.3198L10.2867 15.7478L10.9825 15.052L5.24986 9.31938L10.9825 3.58692Z"
          fill="#595959" />
      </svg>
      <span style="margin-left: 1px;margin-top: -2px;color: #595959;">返回</span>
    </div>

    <div style="height: 100%;width: 100%;">

      <div class="content-head">
        <div class="head-title">已披露</div>
        <div class="head-search">
          <!-- <el-input v-model="searchText" placeholder="证券简称或代码"></el-input> -->

          <div style="width: 70px;text-align: right;">报告期：</div>
          <el-select v-model="stageTemp" @change="changeDate" placeholder="请选择">
            <el-option v-for="(item, index) in stageList" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>

          <div style="width: 7px;"></div>

          <el-button @click="getData">搜索</el-button>
        </div>
      </div>

      <div class="table-box">
        <table cellspacing="0">
          <thead>
            <tr>
              <th>股票代码</th>
              <th>股票名称</th>
              <th>营业收入同比</th>
              <th>净利润同比</th>
              <th>公告日期</th>
              <th>扣非净利润同比</th>
              <th>基本每股收益同比</th>
              <th>每股净资产同比</th>
              <th>净资产收益率</th>
              <th>资产负债率</th>
              <th>毛利率</th>
              <th>详情</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="tableData == null || tableData == undefined || tableData.length == 0">
              <tr>
                <td colspan="99">暂无数据</td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(item, index) in tableData" :key="index">
                <td>{{ item.comCode }}</td>
                <td>{{ item.sname }}</td>
                <td>
                  <div>{{ toMoney(item.yysr) }}</div>
                  <div>{{ toRate(item.yysr_tb) }}</div>
                </td>
                <td>
                  <div>{{ toMoney(item.jlr) }}</div>
                  <div>{{ toRate(item.jlr_tb) }}</div>
                </td>
                <td>{{ toDate(item.publish_date) }}</td>
                <td>
                  <div>{{ toMoney(item.kfjlr) }}</div>
                  <div>{{ toRate(item.kfjlr_tb) }}</div>
                </td>
                <td>
                  <div>{{ toMoney(item.jmgsy) }}</div>
                  <div>{{ toRate(item.jmgsy_tb) }}</div>
                </td>
                <td>
                  <div>{{ toMoney(item.mgjzc) }}</div>
                  <div>{{ toRate(item.mgjzc_tb) }}</div>
                </td>
                <td>{{ toRate(item.jzcsyl) }}</td>
                <td>{{ toRate(item.zcfzl) }}</td>
                <td>{{ toRate(item.mll) }}</td>
                <td>
                  <div class="text-button-enable" @click="viewCompany(item)">分析</div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div class="paging">
        <!-- <div class="pading-total"> -->
        <!-- 共&nbsp;{{ pages }}&nbsp;页&nbsp;&nbsp;&nbsp;&nbsp;当前&nbsp;{{ queryParam.pageNum }}&nbsp;页 -->
        <!-- 共&nbsp;{{ total }}&nbsp;条 -->
        <!-- </div> -->
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 15, 20, 30, 40, 50]"
          :current-page="queryParam.page" :page-size="queryParam.num" :total="total" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" class="paging-pages">
        </el-pagination>
      </div>

    </div>

    <div style="color:#9a9a9a; padding: 5px;margin-top: 30px;">
      免责声明：上述所有信息均基于市场公开数据，经数据自动处理技术和人工智能算法产生，碧湾将尽力但不能保证其绝对准确和可靠，且亦不会承担因任何不准确或遗漏而引起的任何损失或损害的责任。所有数据信息仅供参考，不构成任何投资建议，不代表碧湾观点，投资者据此操作，风险自担。
    </div>

  </div>
</template>
    
<script>
import { linkName, sendRequestIndustry } from '../../../../static/js/util';

export default {
  data() {
    return {
      searchText: '',
      queryParam: {
        node: 'hs',
        year: '',
        page: 1,
        num: 10,
        stage: '',
        jType: 0,
        rType: 0
      },
      stageList: [
        { id: 0, name: '加载中', year: '', stage: '' },
      ],
      stageTemp: 0,
      total: 1,
      pages: 1,
      tableData: []
    };
  },
  mounted() {
    this.getReportDate();
  },
  methods: {
    back() {
      linkName(this, 'market');
    },
    //报告期
    changeDate(newId) {
      var temp = this.stageList[newId];
      this.queryParam.year = temp.year;
      this.queryParam.stage = temp.stage;
    },
    //金额单位转万元
    toMoney(num) {
      var minus = 1;
      if (num < 0) {
        minus = -1;
        num = num * -1;
      }
      if (num < 10000) {
        num = parseFloat(num);
        return minus * num.toFixed(2) + '';
      } else if (num < 100000000) {
        var temp = num / 10000;
        return minus * temp.toFixed(2) + ' 万';
      } else {
        var temp = num / 100000000;
        return minus * temp.toFixed(2) + ' 亿';
      }
    },
    toRate(num) {
      num = parseFloat(num)
      if (isNaN(num)) {
        return '-';
      } else {
        return num.toFixed(2) + '%';
      }
    },
    toDate(date) {
      return date.substring(0, 4) + '-'
        + date.substring(4, 6) + '-'
        + date.substring(6, 8)
    },
    getReportDate() {
      sendRequestIndustry('/sina/productDate',
        'get',
        null,
        res => {
          if (res.data.code == 0) {
            this.queryParam.year = res.data.data.year;
            this.queryParam.stage = res.data.data.stage;
            var yearList = res.data.data.yearList;
            for (var i = 0; i < yearList.length; i++) {
              yearList[i].id = i;
              yearList[i].name = yearList[i].year + '年' + yearList[i].stage;
            }
            this.stageList = yearList;
            this.getData();
          } else {
            // this.$message.error(res.data.msg);
            if (res.data.msg == '5002') {
              this.$alert('您的查看次数已用完，成为VIP即享碧湾所有分析数据', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  window.history.back();
                }
              });
            } else {
              console.log(res.data);
              this.$message.error(res.data.msg);
            }
          }
        }, err => {
          console.log(err);
        })
    },
    //获取数据
    getData() {
      // const loading = this.$loading({
      //     target: $('.table-box')[0],
      //     lock: true,
      //     text: '加载中',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(255, 255, 255, 0.8)'
      // });
      sendRequestIndustry('/sina/product' +
        '?node=' + this.queryParam.node +
        '&year=' + this.queryParam.year +
        '&page=' + this.queryParam.page +
        '&num=' + this.queryParam.num +
        '&stage=' + this.queryParam.stage +
        '&jType=' + this.queryParam.jType +
        '&rType=' + this.queryParam.rType,
        'get',
        null,
        res => {
          // loading.close();
          // console.log(res)
          if (res.data.code == 0) {
            this.tableData = res.data.data.records;
            this.total = res.data.data.total;
            this.pages = res.data.data.pages;
          }
        }, err => {
          // loading.close();
          console.log(err);
        })
    },
    viewCompany(row) {
      window.top.location = '/beawanHome/companyResearch/research?comCode=' + row.comCode + '&name=' + row.sname;
    },
    //每页多少条
    handleSizeChange(num) {
      this.queryParam.num = num;
      this.getData();
    },
    //换页
    handleCurrentChange(index) {
      this.queryParam.page = index;
      this.getData();
    }
  }
};
</script>
    
<style scoped>
@import "../../../../static/css/marketItemView.css";
</style>